<template>
  <XSelect
      v-bind="$attrs"
      v-on="$listeners"
      :options="options"
      :value="value"
      :spin="spin"
      @refresh="loadOptions"
  ></XSelect>
</template>
<script>

export default {
  props:{
    //数据接口
    dataApi: {
      type: Function,
      require: true
    },
    value: [String, Number],
    //参数
    params: Object,
    noneOption: Object,
    //传入该值代表会缓存数据
    dataKey: String,
    init: {
      default: true
    }
  },
  data() {
    return {
      //下拉选列表
      options: [],
      spin: false,
    };
  },
  created() {
    if(this.init){
      //组件创建时加载一次数据
      this.loadOptions()
    }
  },
  mounted() {
  },
  methods: {
    //加载远程下拉选数据
    async loadOptions(){
      if(this.spin) return
      this.spin = true
      try {
        let {data} = await this.dataApi(this.params)
        //有无选择项 则插入到最前
        this.noneOption && data.unshift(this.noneOption)
        this.options = data;
      } catch (e) { console.log(e) }
      this.loadCacheData()
      this.spin = false
    },
    async loadCacheData(){
      if(!this.dataKey) return
      //读取缓存
			let value = this.$storage.get(this.dataKey)
      this.$emit('input', value)
    }
  },
  watch: {
    value(){
      if(!this.dataKey) return
      //存入缓存
			this.$storage.set(this.dataKey, this.value)
    }
  }
};
</script>
<style lang="less" scoped>
</style>